var n = (r, m, e) => Math.max(m, Math.min(e, r)),
  o = r => n(r, 0, 1);
var a = (r, m, e) => (e - m) * r + m,
  b = (r, m, e) => (r - m) / (e - m);
export { n as clamp, o as clamp01, a as mapFrom01Linear, b as mapTo01Linear };
//# sourceMappingURL=out.js.map